import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { buildSchemeAwareChipStyles } from "@themes/utils/gradients";

/**
 * A small outlined pill for a count or a one-word label — "12", "Beta".
 *
 * It was `SidebarMenuListItemBadge` in `MainSidebar.components`, named for the
 * one place it first appeared. By then three layers were rendering it: the
 * sidebar, the employee tables under `domains/`, and the support menu under
 * `hooks/`. It is a styled Box over theme tokens with no knowledge of the app
 * shell, so it is an atom, and the two layers below `layout/` were reaching
 * upward to get it.
 *
 * Distinct from {@link BaseChip}, which is a full MUI Chip with tooltip,
 * loading and icon slots. This is the bare pill.
 */
export const OutlineBadge = styled(Box)(({ theme }) => {
  return {
    ...buildSchemeAwareChipStyles(theme, theme.vars.palette.surface.base),
    alignItems: "center",
    border: `1px solid ${theme.vars.palette.border.subtle}`,
    borderRadius: "8px",
    color: theme.vars.palette.text.tertiary,
    display: "flex",
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    height: "24px",
    justifyContent: "center",
    lineHeight: "24px",
    minWidth: "30px",
    padding: "0 4px"
  };
});
